import { Component } from '@angular/core';
import { HomePage } from '../home/home';
import { ListBillingPage } from '../list-billing/list-billing';
import { SettingsPage } from '../settings/settings';

@Component({
  templateUrl: 'tabs.html'
})
export class TabsPage {

  // tab1Root = HomePage;
  tab1Root = SettingsPage;
  tab2Root = ListBillingPage;
  tab3Root = SettingsPage;

  constructor() {

  }
}



// WEBPACK FOOTER //
// ./src/pages/tabs/tabs.ts